import { addMonths, startOfMonth, subMonths } from 'date-fns';
import { rangeRight, range } from 'lodash-es';
// including current month
export function getLastXMonths(now, num) {
    const startOfThisMonth = startOfMonth(now);
    return rangeRight(num).map((numToSub)=>subMonths(startOfThisMonth, numToSub));
}
// excluding current month
export const getNextXMonths = (now, num)=>{
    const startOfThisMonth = addMonths(startOfMonth(now), 1);
    return range(num).map((numToAdd)=>addMonths(startOfThisMonth, numToAdd));
};
// Always UTC — date-fns `format(date, 'yyyy-MM-dd')` uses local TZ and shifts UTC-aligned
// day boundaries (end-of-Apr-11 UTC = 02:59 Apr 12 in IL), making the BE's UTC-day filter
// off-by-one. Use this for any date-only query param the BE parses as a UTC calendar day.
export const serializeDateUtc = (date)=>date ? date.toISOString().slice(0, 10) : undefined;
